module.exports = __webpack_public_path__ + "static/media/close-circle.dc6a699a.svg";